import { command, type Store } from 'ccstate';
import { StoreProvider } from 'ccstate-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setRootSignal$ } from '../common/ccstatex/rootSignal.ts';
import { initAuthStates$ } from './infra/authClient.ts';
import { initRoutes$ } from './infra/router/navigate.ts';
import * as stateTreeRoot from './state/index.ts';
import { setupPrototype } from './prototype/setupPrototype.ts';
import CurrentPage from './CurrentPage.tsx';
import './index.css';
import { injectState } from '../common/ccstatex/injectState.ts';
import { takeStateSnapshot } from '../common/ccstatex/takeStateSnapshot.ts';
import './pages/index.ts';
const bootstrap$ = command(async ({ get, set }, store: Store) => {
    const rootController = new AbortController();
    if (process.env.VITE_USE_PROTOTYPE === 'true') {
        set(setupPrototype);
    }
    set(setRootSignal$, rootController.signal);
    if (process.env.VITE_USE_INJECTED_STATE === 'true') {
        const FAKE_JSON = globalThis._injected;
        injectState(stateTreeRoot, FAKE_JSON);
    }
    globalThis.takeStateSnapshot = async () => {
        console.log(await takeStateSnapshot(get, stateTreeRoot));
    };
    if (process.env.VITE_USE_INJECTED_STATE !== 'true') {
        set(initAuthStates$);
    }
    createRoot(document.getElementById('bundler-root')!).render(<StrictMode data-id="mhcm24">
      <StoreProvider value={store} data-id="qxmnec">
        <CurrentPage data-id="gatf50"/>
      </StoreProvider>
    </StrictMode>);
    await set(initRoutes$, rootController.signal);
});
export const bootstrap = async (store: Store) => {
    await store.set(bootstrap$, store);
};
